'use client';

import { type ButtonProps } from '@ironhack/design-system2/components/button';
import { Flex, type FlexProps } from '@ironhack/design-system2/components/flex';
import { Text } from '@ironhack/design-system2/components/text';
import { Mail } from '@ironhack/design-system2/icons/mail';
import { assocPath } from 'ramda';
import { type ReactElement, useEffect } from 'react';

import { Button } from '@/app/components/client/button';
import { ConfettiBox } from '@/app/components/client/confetti-box';
import { type ThankYouSession } from '@/hooks/use-thank-you-session';
import { type DatoButtonBlock } from '@/lib/datocms';

type Props = {
  button: [DatoButtonBlock];
  buttonProps?: ButtonProps;
  preStudentPortalButton?: DatoButtonBlock | null;
  text: string;
  thankYouSession?: ThankYouSession;
  title: string;
} & FlexProps;

export const FormThankYou = (props: Props): ReactElement => {
  const {
    button: [button],
    buttonProps,
    preStudentPortalButton,
    text,
    thankYouSession,
    title,
    ...flexProps
  } = props;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  let thankYouButton = button;

  if (preStudentPortalButton) {
    const preStudentPortalUrl =
      thankYouSession?.magicLink ??
      thankYouSession?.applicantInfo.yourIronhackUrl;
    thankYouButton = preStudentPortalUrl
      ? assocPath(
          ['target', 0],
          { link: preStudentPortalUrl },
          preStudentPortalButton
        )
      : preStudentPortalButton;
  }

  return (
    <Flex alignItems="center" direction="column" w="full" {...flexProps}>
      <Text textStyle="2xl">{title}</Text>
      <ConfettiBox h="104px" icon={Mail} mt={1} />
      <Text mt={3} textStyle="l">
        {text}
      </Text>
      <Button {...thankYouButton} mt={3} {...buttonProps} />
    </Flex>
  );
};
